import { useAuth } from '~/composables/useAuth'

export default defineNuxtRouteMiddleware(async () => {
  const { checkSession } = useAuth()
  const hasSession = await checkSession()
  if (!hasSession) return navigateTo(ROUTES.LOGIN)
})
